/* BareLow — product page, tracking, shoe finder, support. Requires bf.js */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const BF = window.BF || {};

  $$('[data-bf-product]').forEach((root) => {
    const P = JSON.parse($('[data-bf-product-json]', root).textContent);
    const sets = $$('[data-bf-opt]', root);
    const vid = $('[data-bf-vid]', root), atc = $('[data-bf-atc]', root), lab = $('[data-bf-atc-label]', root), err = $('[data-bf-error]', root);
    const val = (fs) => { const r = $('input:checked', fs); if (r) return r.value; const s = $('select', fs); return s ? s.value : null; };
    const sel = () => sets.map(val);
    const find = (o) => P.variants.find((v) => v.options.every((x, i) => x === o[i]));
    const slides = $('[data-bf-slides]', root), thumbs = $$('[data-bf-thumb]', root), gdots = $$('[data-bf-gdot]', root);
    const showMedia = (id, smooth = true) => { const s = slides && $(`[data-media-id="${id}"]`, slides); if (s) slides.scrollTo({ left: s.offsetLeft - slides.offsetLeft, behavior: smooth ? 'smooth' : 'auto' }); };
    if (slides) {
      slides.addEventListener('scroll', () => { const i = Math.round(slides.scrollLeft / slides.clientWidth); thumbs.forEach((t, n) => t.classList.toggle('is-on', n === i)); gdots.forEach((t, n) => t.classList.toggle('is-on', n === i)); }, { passive: true });
      thumbs.forEach((t, n) => t.addEventListener('click', () => slides.scrollTo({ left: n * slides.clientWidth, behavior: 'smooth' })));
    }
    const paintAvail = () => {
      const s = sel();
      sets.forEach((fs, idx) => {
        $$('input[type=radio]', fs).forEach((inp) => { const t = s.slice(); t[idx] = inp.value; const c = P.variants.filter((v) => v.options.every((o, i) => i === idx ? o === inp.value : o === t[i])); inp.nextElementSibling.classList.toggle('is-soldout', !c.some((v) => v.available)); });
        $$('select option', fs).forEach((op) => { if (!op.value) return; if (!op.dataset.lab) op.dataset.lab = op.textContent; const t = s.slice(); t[idx] = op.value; const v = find(t); op.textContent = op.dataset.lab + (!v ? ' – not available' : !v.available ? ' – sold out' : ''); });
      });
    };
    const update = (user) => {
      const s = sel();
      sets.forEach((fs, i) => { const l = $('[data-bf-opt-value]', fs); if (l) l.textContent = s[i] || ''; });
      paintAvail();
      const v = find(s);
      const ref = v || P.variants.find((x) => P.colourIndex < 0 || x.options[P.colourIndex] === s[P.colourIndex]) || P.variants[0];
      $$('[data-bf-now]', root).forEach((e) => { e.textContent = BF.money(ref.price); });
      $$('[data-bf-was]', root).forEach((e) => { e.textContent = ref.compare > ref.price ? BF.money(ref.compare) : ''; e.hidden = !(ref.compare > ref.price); });
      if (!v) { vid.value = ''; atc.disabled = true; lab.textContent = 'Unavailable'; }
      else {
        vid.value = v.id; atc.disabled = !v.available; lab.textContent = v.available ? P.atc : 'Sold out';
        if (user) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      }
      const m = (v || ref).media;
      if (m) showMedia(m, user);
      if (ref.img) { const oi = $('[data-bf-offer-img]', root); if (oi) oi.src = ref.img; }
    };
    sets.forEach((fs) => fs.addEventListener('change', () => { if (err) err.hidden = true; update(true); }));
    $('[data-bf-form]', root).addEventListener('submit', async (e) => {
      e.preventDefault();
      const id = parseInt(vid.value, 10);
      if (!id) { err.textContent = 'Please choose an available option.'; err.hidden = false; return; }
      atc.classList.add('is-loading');
      try { await BF.add([{ id, quantity: 1 }]); } catch (x) { err.textContent = x.message; err.hidden = false; }
      atc.classList.remove('is-loading');
    });
    const st = $('[data-bf-sticky]', root);
    if (st && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => st.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(atc);
      $('button', st).addEventListener('click', () => atc.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }
    if (document.readyState === 'complete') update(false); else window.addEventListener('load', () => update(false));
  });

  $$('[data-bf-sizechart]').forEach((b) => b.addEventListener('click', () => {
    const d = document.getElementById('SizeGuide'); if (!d) return;
    d.hidden = false; requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
    document.body.classList.add('has-drawer');
  }));

  $$('[data-bf-track]').forEach((w) => {
    const tabs = $$('[role=tab]', w);
    tabs.forEach((t) => t.addEventListener('click', () => tabs.forEach((x) => { x.setAttribute('aria-selected', String(x === t)); document.getElementById(x.getAttribute('aria-controls')).hidden = x !== t; })));
    const f = $('[data-bf-track-num]', w);
    if (f) f.addEventListener('submit', (e) => {
      e.preventDefault(); const n = $('input', f).value.trim().replace(/\s+/g, ''); const er = $('[data-bf-track-err]', f);
      if (!/^[A-Za-z0-9-]{6,40}$/.test(n)) { er.hidden = false; return; } er.hidden = true;
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(n), '_blank', 'noopener');
    });
  });

  $$('[data-bf-topic]').forEach((a) => a.addEventListener('click', (e) => {
    const d = $('#BfContact'); if (!d) return; e.preventDefault(); d.open = true;
    const s = $('[name="contact[subject]"]', d); if (s) s.value = a.dataset.bfTopic;
    d.scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(() => { const f = $('input:not([type=hidden])', d); if (f) f.focus(); }, 400);
  }));

  $$('[data-bf-quiz]').forEach((q) => {
    const steps = $$('[data-step]', q), start = $('[data-bf-quiz-start]', q), res = $$('[data-result]', q), prog = $('[data-bf-prog]', q), pw = $('[data-bf-prog-wrap]', q);
    const answers = [];
    const show = (n) => {
      start.hidden = n !== -1; steps.forEach((s, k) => { s.hidden = k !== n; });
      pw.hidden = n < 0 || n >= steps.length; if (prog) prog.style.width = ((n + 1) / steps.length * 100) + '%';
      if (n >= steps.length) {
        const pick = answers.map((a) => a && a.r).filter(Boolean).pop() || res[0].dataset.result;
        res.forEach((r) => { r.hidden = r.dataset.result !== pick; });
        if (BF.initCarousels) { BF.initCarousels(q); BF.initCards(q); }
      } else res.forEach((r) => { r.hidden = true; });
      q.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    $('[data-bf-quiz-go]', q).addEventListener('click', () => show(0));
    steps.forEach((s, k) => {
      $$('[data-answer]', s).forEach((b) => b.addEventListener('click', () => { answers[k] = { a: b.dataset.answer, r: b.dataset.route || '' }; show(k + 1); }));
      const back = $('[data-back]', s); if (back) back.addEventListener('click', () => show(k - 1));
    });
    $$('[data-restart]', q).forEach((b) => b.addEventListener('click', () => { answers.length = 0; show(-1); }));
  });
})();